import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "prevButton", "nextButton", "slide"]

  connect() {
    this.slideWidth = this.slideTargets[0].offsetWidth
  }

  next() {
    this.scrollBy(this.slideWidth)
  }

  prev() {
    this.scrollBy(-this.slideWidth)
  }

  scrollBy(amount) {
    this.containerTarget.scrollBy({ left: amount, behavior: "smooth" })
  }
}
